import React from "react";
// import classNames from "classnames"
import { graphql, useStaticQuery } from "gatsby";

import Button from "../primitives/Button";
import WrapArrow from "../primitives/WrapArrow";

// import TicketsBanner from "../layout/TicketsBanner";
// import Link from "../components/Link";
import { Link } from "gatsby";

// import RenderRichContent from "../../components/containers/RenderRichContent";
import EmojiIcon from "../primitives/EmojiIcon";
// const linkClasses = dark =>
//   classNames({
//     "link font-sans": !dark,
//     "outline-none focus:shadow-outline": dark,
//   })

const Footer = ({ dark }) => {
  const { sanitySiteSettings } = useStaticQuery(
    graphql`
      query {
        sanitySiteSettings {
          footerMenu {
            text
            internalPage {
              ... on SanityArticle {
                id
                _type
                slug {
                  current
                }
                title
              }
              ... on SanityPages {
                id
                slug {
                  current
                }
                title
              }
            }
            url
          }
          _rawFooterContent(resolveReferences: { maxDepth: 10 })
        }
      }
    `
  );

  // const content = sanitySiteSettings._rawFooterContent || [];
  const {
    footerMenu = [],
    // content = sanitySiteSettings._rawFooterContent || [], // TODO: Remove this when new menu is finished
  } = sanitySiteSettings;

  // Footer menu links
  const RenderFooterLinks = () => {
    return footerMenu.map((link, i) => {
      const { text, url, internalPage } = link;

      if (internalPage) {
        const { slug } = internalPage;
        return (
          <li
            className="
              flex
              pointer-events-none
            "
            key={`menu_item_${i}`}
          >
            <Link
              className="group text-md font-bold pointer-events-auto"
              to={`/${slug.current}`}
            >
              <WrapArrow
                className="group-hover:text-green-dark"
                direction="right"
              />
              <span className="ml-1 !leading-1-2 group-hover:text-green-dark">
                {text}
              </span>
            </Link>
          </li>
        );
      }
      return (
        <li
          className="
            flex
            pointer-events-none
          "
          key={`menu_item_${i}`}
        >
          <a
            className="
              block
              group text-md pointer-events-auto
              font-bold
            "
            href={url}
            rel={`noopener noreferrer`}
          >
            <WrapArrow
              className="group-hover:text-green-dark"
              direction="right"
            />
            <span className="inline-block ml-1 !leading-1-2 group-hover:text-green-dark">
              {text}
            </span>
          </a>
        </li>
      );
    });
  };

  return (
    <footer
      className="
        flex flex-col
        border-solid border-black border-t xl:border-t-6
      "
    >
      <div
        className="
          w-full
          flex flex-col
          items-center
          justify-center
          pt-6
          pb-10
        "
      >
        <h2 className="text-md"> FOLLOW Y ON</h2>
        <div className="flex flex-col space-y-10 md:space-y-6 sm:flex-row-reverse pt-4">
          <Button
            className="-rotate-6 md:ml-20 border-none"
            color="green"
            href="https://facebook.com/Y.Oslo.Intervention"
            externalLink
          >
            <EmojiIcon name="someFacebook" /> Facebook
          </Button>

          <Button
            className="rotate-6 border-none"
            color="green"
            href="https://instagram.com/y_oslo"
            externalLink
          >
            <EmojiIcon name="someInstagram" /> Instagram
          </Button>
        </div>
      </div>

      <div
        className="
          flex flex-wrap
          w-full
          pt-10
          pb-10
          border-solid border-black border-t xl:border-t-6
        "
      >
        <div className="w-full md:w-3/6 mb-3 leading-1-2 font-bold">
          <Link className="hover:text-green-dark" to="/">
            Y <br />
            Oslo
          </Link>
        </div>

        <div className="flex flex-wrap w-full md:w-3/6">
          <ul>
            {/* <RenderRichContent content={content} /> */}
            <RenderFooterLinks />

            {/* <li className="flex items-center mt-2">
              <span className="leading-none">
                Y Oslo is an event by
                <a
                  className="
                    inline-block
                    mt-1 ml-1
                    netlife-sans-logo
                    font-bold leading-none
                    hover:text-green-dark hover:border-green-dark
                  "
                  href="https://www.netlife.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Netlife
                </a>
              </span>
            </li> */}
          </ul>

          {/* {items.map(item => (
          <div className="w-full md:w-1/2" key={item._key}>
            <Link
              href={item.url}
              slug={item.internalPage?.slug?.current}
              noFollow={item.nofollow}
              className={linkClasses(dark)}
            >
              {item.text}
            </Link>
          </div>
        ))} */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
